import React, { useEffect } from "react";
import s from "../styles/PolicyLayout.module.css";
import GradientBackground from "../pages/home/GradientBackground";
import { buildSeoTitle } from "../utils/seoTitle";

function PolicyLayout({ title, appName, date, children }) {
  useEffect(() => {
    document.title = buildSeoTitle(appName, title);
  }, [appName, title]);

  return (
    <>
      <GradientBackground />

      <div className={s.style}>
        <div className={s.central_text}>{title}</div>
        <div className={s.central_text_app_name}>{appName}</div>
        <div className={s.date}>{date}</div>

        <section className={s.policy_text}>{children}</section>
      </div>
    </>
  );
}

export default PolicyLayout;
